// extracted by mini-css-extract-plugin
export default {"loading-holder":"loader-module__loading-holder__2zBe5"};